export const AW_PORTFOLIO_ANALYSIS_REPORTS_API_URL =
  process.env?.AW_PORTFOLIO_ANALYSIS_REPORTS_API_URL || '/api/wealth/analytics/reporting/v1';
